import { DynamicObjectInterface } from '../../../sdk/type';
import { DetailCardProgress } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';

export const getParticipantListConfig: GetColumnsType = () => [
  {
    key: '',
    width: 20,
    sortable: true,
    render: (object: DynamicObjectInterface) => {
      return (
        <DetailCardProgress
          {...(object as DynamicObjectInterface)}
          showCoachDetail={true}
          coachId={object.teamDetail.coachId}
          coachName={object.teamDetail.coachName}
          profileImageUrl={object.imageUrl}
          isCoachEnrollment={true}
          showFiveProgress={false}
        />
      );
    },
  },
];
